import React, { FC }                  from 'react';
import { Cell, Grid }                 from 'styled-css-grid';
import { Icon, Popup, SemanticICONS } from 'semantic-ui-react';

import { UseIf }                           from '../../../../../components/display/EqualValues';
import { DataCopyMenu, DataCopyMenuProps } from '../../../../../components/menus/DataCopyMenu';

export enum ChartReportingViewType {
	CHART,
	CUSTOM,
	TABLE,
	NONTABLE
}

interface Props {
	enableTableToggle?: boolean,
	enableDataCopy?: boolean,
	
	dataCopyMenuProps?: DataCopyMenuProps,
	nonTableViewLabel?: string,
	nonTableViewIcon?: SemanticICONS,
	onClickNonTableView?: () => void,
	
	onClickTableView?: () => void,
	
	viewType?: ChartReportingViewType.TABLE | ChartReportingViewType.NONTABLE,
}

const defaultProps: Props = {
	enableTableToggle: true,
	dataCopyMenuProps: {},
	
	nonTableViewLabel: 'Chart',
	nonTableViewIcon:  'chart bar outline',
}

const ChartReportViewControls: FC<Props> = ( props ) => {
	
	const isTableView    = ( props.viewType === ChartReportingViewType.TABLE ),
	      isNontableView = ( props.viewType === ChartReportingViewType.NONTABLE );
	
	return (
		
		<Grid
			columns={ `auto 1fr auto` }
			areas={ [ 'toggle-controls . download-controls' ] }
			columnGap={ `0px` }>
			
			<Cell middle area={ 'download-controls' }>
				
				<UseIf x={ props.enableDataCopy }>
					
					<DataCopyMenu
						label={ 'Download' }
						icon={ 'download' }
						{ ...props.dataCopyMenuProps }
					/>
				
				</UseIf>
			
			</Cell>
			
			<Cell></Cell>
			
			<Cell middle area={ 'toggle-controls' }>
				
				<UseIf x={ props.enableTableToggle }>
					
					<Grid columns={ `auto auto` } columnGap={ `25px` }>
						
						<Cell middle>
							
							<Popup
								size={ 'tiny' }
								disabled={ isNontableView }
								position={ 'top center' }
								content={ `View as ${ props.nonTableViewLabel }` }
								trigger={ <Icon fitted
								                name={ props.nonTableViewIcon }
								                className={ isTableView ? 'cursor--pointer opacity--80 opacity-hover--100' : null }
								                color={ isNontableView ? 'grey' : 'purple' }
								                onClick={ isTableView ? props.onClickNonTableView : null }
								/> }
							/>
						
						</Cell>
						<Cell middle>
							
							<Popup
								size={ 'tiny' }
								disabled={ isTableView }
								position={ 'top center' }
								content={ `View as data table` }
								trigger={ <Icon fitted
								                name={ 'table' }
								                className={ isNontableView ? 'cursor--pointer opacity--80 opacity-hover--100' : null }
								                color={ isTableView ? 'grey' : 'purple' }
								                onClick={ isNontableView ? props.onClickTableView : null }
								/> }
							/>
						
						</Cell>
					</Grid>
				
				</UseIf>
			
			</Cell>
		</Grid>
	);
};

ChartReportViewControls.defaultProps = defaultProps;

export { ChartReportViewControls }
